import type { FC } from 'react';
import { CommentList } from '@/Module/Comment/Component';
const LessonDetailCommentList: FC = () => {
  return <div className=" md:mb-8 lg:mb-16" data-sentry-component="LessonDetailCommentList" data-sentry-source-file="LessonDetailCommentList.tsx">
      <CommentList data-sentry-element="CommentList" data-sentry-source-file="LessonDetailCommentList.tsx" />
    </div>;
};
export default LessonDetailCommentList;